import React from "react";
import { Typography, Container, Divider } from "@material-ui/core";

function Education() {
	return (
		<Container maxWidth="md">
			<Typography variant="h4" align="center">
				Education
			</Typography>
			<Typography variant="body1" style={{ fontWeight: "bold" }}>
				City@UMD faculty collated the following list of graduate courses offered
				in three different colleges on the topic of Sustainability in the Built
				Environment:
			</Typography>
			<br />
			<div id="mech">
				<Typography variant="h5" align="center">
					A. James Clark School of Engineering / Mechanical and Civil
					Engineering Courses:
				</Typography>
				<div className="courses">
					<Typography variant="h6">
						ENME742i / ENME424: Urban Microclimate and Energy
						<small>(Instructor: Srebric)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Urban microclimate from the perspective of transient heat and mass
						transfer using building energy simulations for building clusters as
						well as LEED building certification criteria. The focus is on
						understanding building energy consumption and environmental impacts
						from the individual building scale to a neighborhood scale
					</Typography>
					<Typography variant="h6">
						ENME 701: Sustainable Energy Conservation and the Environment
						<small>(Instructor: Radermacher)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Discussion of the major sources and end-uses of energy in our
						society with particular emphasis on renewable energy production and
						utilization. Introduces a range innovative technologies and
						discusses them in the context of the current energy infrastructure.
						Renewable sources such as wind and solar are discussed in detail.
						Particular attention is paid to the environmental impact of the
						various forms of energy.
					</Typography>
					<Typography variant="h6">
						ENME 808W/ENME 489N: Advanced Energy Audit and Conservation
						<small>(Instructor: Neil Schulman)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Students will be provided with current and future trends in energy
						resources and technologies while providing them with the necessary
						skills to conduct energy audit/analysis on both commercial and
						residential facilities. Energy accounting procedures for electrical,
						mechanical and HVAC systems will be covered in detail, along with
						economics/life-cycle costing analysis.
					</Typography>
					<Typography variant="h6">
						ENME 808P/489M: Ultra-low Energy Use Appliance Design
						<small>(Instructor: Neil Schulman)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						The goal of the course is to drive energy efficiency innovation in
						appliances and equipment used in and around U.S. buildings. To
						achieve this goal, the course will address and discuss in detail on
						the psychrometric processes, vapor compression cycles, appliances
						and heat exchanger designs. Students will gain a thorough
						understanding of the potentials of these emerging technologies and
						experience various aspects of research and development in
						engineering.
					</Typography>
					<Typography variant="h6">
						ENCE 604: Sustainability for Project Managers
						<small>(Instructor: Neil Schulman)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						This course addresses the fundamentals of sustainability for project
						managers including best practices of modern sustainable construction
						and project management. Commercial and residential buildings consume
						about 40 percent of the energy used in the United States. The course
						therefore emphasizes the application of the sustainable development
						standards to the built environment, including the practical
						operational aspects of sustainable facility project management.
					</Typography>
				</div>
			</div>
			<Divider style={{ margin: 8 }} />
			<div id="nat">
				<Typography variant="h5" align="center">
					School of Architecture Planning and Preservation / Architecture:
				</Typography>
				<div className="courses">
					<Typography variant="h6">
						ARCH 418M: Measuring Sustainability
						<small>(Instructor: Ralph Bennett)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Studies metrics of sustainability as included in rating standards,
						including LEED. All students will take the LEED GA test. Course
						offered in fall semester.
					</Typography>
					<Typography variant="h6">
						ARCH 460: Site Analysis and Design
						<small>(Instructor: Margaret McFarland or designee)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						ARCH majors only. Prerequisite: ARCH 400 or permission of
						department. Principles and methods of site analysis; the influence
						of natural and man-made site factors on site design and
						architectural form. Course offered in spring semester.
					</Typography>
					<Typography variant="h6">
						ARCH 461: Sustainability in Architecture
						<small>(Instructor: Margaret McFarland or designee)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Prerequisite: ARCH 401 and ARCH 410 or permission of department.
						Strategies of sustainability as related to the broader context of
						architectural problem solving.
					</Typography>
					<Typography variant="h6">
						RDEV 688Y: Practical Issues in Sustainability
						<small>(Instructor: Margaret McFarland or designee)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						This is a practical issues course addressing the business impacts
						and drivers of sustainability. Students taking this class will
						receive broad-based business issue exposure to a wide range of
						sustainability-oriented topics and be challenged to think about the
						business issues and impacts of sustainability across numerous
						subject matters. The goal is for students to apply macro insights
						gained from this class to their ongoing curriculum, coursework class
						assignments, and professional careers.
					</Typography>
				</div>
			</div>
			<Divider style={{ margin: 8 }} />
			<div id="arch">
				<Typography variant="h5" align="center">
					College of Agriculture and Natural Resources / Environmental Science
					and Technology:
				</Typography>
				<div className="courses">
					<Typography variant="h6">
						ENST 681: Advanced Ecological Design
						<small>
							(Instructor: Stephanie Lansing, offered every other Spring)
						</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						This is an advanced survey course on the field of ecological design
						and engineering. Principles of ecological engineering are applied
						through design of biologically-based waste treatment systems.
					</Typography>
					<Typography variant="h6">
						ENST 689J: Valuing Ecosystem Services
						<small>(Instructor: Bob Tjaden, offered Fall)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						This course discusses the importance of our ecosystems and the
						services they provide. Forestland, wetlands and our marine resources
						are increasingly recognized for their ecosystem services provided to
						society, to include clean air and water, wildlife habitat,
						biodiversity, carbon storage and pollination services. This course
						will prepare students to deal with the complex issues involved in
						understanding those and other ecosystem services and their
						importance to society and environmental sustainability.
					</Typography>
					<Typography variant="h6">
						ENST 643: Advanced Industrial Ecology
						<small>(Instructor: Patrick Kangas, offered Spring)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Problems of waste management and recycling in human societies are
						covered. The industrial ecology approach to design is contrasted
						with analogous patterns and processes from natural ecosystems.
					</Typography>
					<Typography variant="h6">
						ENST 653: Watershed Science: Water Balance, Open Channel Flow, and
						Near Surface Hydrology
						<small>(Instructor: TBD, offered Spring)</small>
					</Typography>
					<Typography variant="h6">
						ENST 652: Wetland Creation and Restoration
						<small>(Instructor: A Baldwin)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Design, construction, and evaluation of wetlands restored or created
						for ecosystem enhancement or mitigation. Topics will include
						ecological restoration theory, goal-setting, practices for
						establishing wetland hydrology, substrate, and vegetation, and
						restored ecosystem monitoring and functional assessment.
					</Typography>
					<Typography variant="h6">
						ENST 605: Energy and the Environment
						<small>(Instructor: David Tilley, offered Spring)</small>
					</Typography>
					<Typography variant="body1" gutterBottom>
						Role of energy in environmental and human-dominated systems and
						their linkage. Discussion of the historical and modern production
						and consumption of energy. Energy systems simulation modeling,
						energy analysis and energy auditing. Review of national energy
						policies and proposed alternatives.
					</Typography>
				</div>
			</div>
		</Container>
	);
}
export default Education;
